import React, { useEffect, useState } from "react";
import "./metatagseo.css";
import { Button } from "@mui/material";

import { useNavigate } from "react-router-dom";
import { getPage_Category } from "../auth/service";
import CardPageCategory from "./PageCardCategory";

const AddCategory = () => {
  const [pageCategoryData, setPageCategoryData] = useState();

  const navigate = useNavigate();

  const fetchPageCategoryData = async () => {
    try {
      const response = await getPage_Category();
      setPageCategoryData(response?.data);
      console.log(response?.data, "page category data");
    } catch (error) {
      // setError(error);
    } finally {
      // setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchPageCategoryData();
  }, []);

  const handleNavigate = async () => {
    navigate("/dashboard/metatags/application-category", {});
  };

  return (
    <div className="metaTag-container">
      <div className="metaTag-header-container">
        <span className="metaTag-header">Page Meta tags and Seo</span>
        <div className="btn-container">
          <Button
            variant="contained"
            className="bordered-button"
            onClick={handleNavigate}
          >
            ADD PAGE CATEGORY
          </Button>
        </div>
      </div>

      {pageCategoryData?.length > 0 ? (
        <div className="category-card-wrapper">
          {pageCategoryData.map((pagecategorylist) => (
            <div
              className="category-card-container-application"
              key={pagecategorylist?._id}
            >
              <CardPageCategory
                pagecategorylist={pagecategorylist}
                active={pagecategorylist?.active}
                refreshList={fetchPageCategoryData}
              />
            </div>
          ))}
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default AddCategory;
